import { get as e, useFormState as t } from "react-hook-form";
//#region src/hooks/shared/useErrorIndicator.ts
var n = {
	general: [
		"name",
		"company",
		"collectorSettings.global.fileLog",
		"collectorSettings.global.debugMode",
		"syncSettings.enhancePointsWithSyncTime"
	],
	"local-storage": ["localDatabaseConfig"],
	collector: [
		"collectorSettings.connections",
		"collectorSettings.global.minStorageAvailable",
		"collectorSettings.global.maxBufferPoints",
		"collectorSettings.global.writeTimeout"
	],
	replicator: ["collectorSettings.global.mirrors"],
	"ads-router": ["collectorSettings.global.adsRouterSettings"],
	analytics: ["analyticsSettings"],
	"cloud-manager": [
		"cloudManagerSettings",
		"edgeCloudBusSettings",
		"collectorSettings.global.mqttEndpoint",
		"collectorSettings.global.enableMqtt"
	],
	"edge-bus": ["edgeBusSettings"],
	syncer: ["syncSettings"],
	variables: ["configTags"],
	triggers: ["collectorSettings.triggers"]
}, r = {
	configuration: [
		"enabled",
		"name",
		"type",
		"address",
		"port",
		"cpuType",
		"rack",
		"slot",
		"requestDelay",
		"readCycleDelay",
		"dbId",
		"unitId",
		"byteSwap",
		"isTimeManager"
	],
	tags: ["tags"],
	"condition-trigger": ["conditionTriggers"],
	measurements: ["measurements"],
	"custom-settings": ["custom"]
}, i = () => {
	let { errors: i } = t();
	return {
		hasError: (t) => n[t] ? !n[t].every((t) => {
			let n = e(i, t) || {};
			return Object.keys(n).length === 0;
		}) : !1,
		hasConnectionError: (t, n) => r[t] ? !r[t].every((t) => {
			let r = e(i, `collectorSettings.connections.${n}.` + t) || {};
			return Object.keys(r).length === 0;
		}) : !1
	};
};
//#endregion
export { i as n, r as t };

//# sourceMappingURL=useErrorIndicator-CgX9KKji.js.map